import React, { useState } from "react";
import { Box, TextField, Button, Snackbar, Alert } from "@mui/material";
import { saveCampaignMessage } from "../../../services/schedule";

const CreateNewCampaignMessage = ({ onCreate }) => {
  const [channel, setChannel] = useState("");
  const [language, setLanguage] = useState("");
  const [dpd, setDpd] = useState("");
  const [stateVal, setStateVal] = useState("");
  const [fromDbaName, setFromDbaName] = useState("");
  const [template, setTemplate] = useState("");
  const [message, setMessage] = useState("");
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const handleCreate = async () => {
    if (!message || message.trim() === "") {
      setSnackbar({ open: true, message: "Message is required", severity: "error" });
      return;
    }
    const payload = {
      Channel: channel,
      Language: language,
      DPD: dpd,
      State: stateVal,
      FromDBAName: fromDbaName,
      TemplateName: template,
      Description: message,
    };
    try {
      setSnackbar({ open: true, message: "Saving...", severity: "info" });
      const result = await saveCampaignMessage(payload);
      setSnackbar({ open: true, message: "Saved", severity: "success" });
      if (typeof onCreate === "function") onCreate(result);
    } catch (err) {
      console.error("Failed to save message", err);
      setSnackbar({ open: true, message: "Failed to save", severity: "error" });
    }
  };

  return (
    <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "1fr 1fr" }}>
  <TextField size="small" label="Channel" value={channel} onChange={(e) => setChannel(e.target.value)} sx={{ gridColumn: "1 / 2" }} />

      <TextField size="small" label="Language" value={language} onChange={(e) => setLanguage(e.target.value)} sx={{ gridColumn: "2 / 3" }} />

      <TextField size="small" label="DPD" value={dpd} onChange={(e) => setDpd(e.target.value)} sx={{ gridColumn: "1 / 2" }} />

      <TextField size="small" label="State" value={stateVal} onChange={(e) => setStateVal(e.target.value)} sx={{ gridColumn: "2 / 3" }} />

      <TextField size="small" label="FromDBAName" value={fromDbaName} onChange={(e) => setFromDbaName(e.target.value)} sx={{ gridColumn: "1 / 2" }} />

      <TextField size="small" label="Template" value={template} onChange={(e) => setTemplate(e.target.value)} sx={{ gridColumn: "2 / 3" }} />

      <TextField
        label="Message"
        multiline
        minRows={4}
        maxRows={8}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        sx={{ gridColumn: "1 / 3" }}
      />

      <Box sx={{ display: "flex", gap: 1, gridColumn: "1 / 3" }}>
        <Button variant="contained" onClick={handleCreate}>
          Create
        </Button>
      </Box>

      <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar((s) => ({ ...s, open: false }))}>
        <Alert severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CreateNewCampaignMessage;